module.exports = __webpack_public_path__ + "img/smsicon.f2e76899.png";